<ag-status-chip [status]="this.status" class="status-column"></ag-status-chip>
